/* VAPE DOKHA AI CONCIERGE v3.1 UI — WhatsApp-style look, language selector,
   compact quick actions. Replaces assets/vapedokha-concierge-ui.js.
   Server-side conversation (cid), live polling (owner takeover), voice notes. */
document.addEventListener("DOMContentLoaded", function () {

  var WORKER_URL = "https://vapedokha-com-ai-concierge.yellow-dawn-e129.workers.dev";
  var WHATSAPP = "971569008781";
  var KEY = "vdc3Chat";

  /* ---------- languages ---------- */
  var LANGS = {
    en: { name: "English", label: "English", rtl: false,
      greet: "Ahlan! 👋 Ask me anything — products, orders, tracking. How can I help?",
      chips: ["📦 Track my order", "🌍 Shipping", "🛒 Order for me"],
      qShip: "Do you ship to my country and how long does it take?",
      qOrder: "I want to buy now — help me order",
      ph: "Ask anything…" },
    ar: { name: "Arabic", label: "العربية", rtl: true,
      greet: "أهلاً! 👋 اسألني عن أي شيء — المنتجات، الطلبات، التتبع. كيف أقدر أساعدك؟",
      chips: ["📦 تتبع طلبي", "🌍 الشحن", "🛒 اطلب لي"],
      qShip: "هل تشحنون إلى بلدي وكم يستغرق التوصيل؟",
      qOrder: "أريد الشراء الآن — ساعدني بالطلب",
      ph: "اكتب سؤالك…" },
    fr: { name: "French", label: "Français", rtl: false,
      greet: "Bienvenue ! 👋 Posez-moi vos questions — produits, commandes, suivi. Comment puis-je vous aider ?",
      chips: ["📦 Suivre ma commande", "🌍 Livraison", "🛒 Commander"],
      qShip: "Livrez-vous dans mon pays et en combien de temps ?",
      qOrder: "Je veux commander maintenant — aidez-moi",
      ph: "Écrivez ici…" },
    es: { name: "Spanish", label: "Español", rtl: false,
      greet: "¡Hola! 👋 Pregúntame lo que quieras — productos, pedidos, seguimiento. ¿Cómo puedo ayudarte?",
      chips: ["📦 Rastrear mi pedido", "🌍 Envíos", "🛒 Pedir por mí"],
      qShip: "¿Envían a mi país y cuánto tarda?",
      qOrder: "Quiero comprar ahora — ayúdame a pedir",
      ph: "Escribe aquí…" }
  };
  var sel = null;
  try { sel = localStorage.getItem(KEY + "Lang"); } catch (e) {}
  if (!sel || !LANGS[sel]) {
    var nav = (navigator.language || "en").slice(0, 2).toLowerCase();
    sel = LANGS[nav] ? nav : "en";
  }

  /* ---------- styles (WhatsApp look) ---------- */
  var css = document.createElement("style");
  css.textContent =
    "#vdc2-launch{position:fixed;right:20px;bottom:20px;width:54px;height:54px;z-index:9999999;background:#25D366;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,.25);animation:vdc2pulse 4s infinite ease-in-out;transition:transform .3s ease}" +
    "#vdc2-launch:hover{transform:scale(1.1)}" +
    "@keyframes vdc2pulse{0%,100%{transform:scale(1);box-shadow:0 0 8px rgba(0,0,0,.2)}50%{transform:scale(1.05);box-shadow:0 0 14px rgba(37,211,102,.6)}}" +
    "#vdc2-panel{position:fixed;right:20px;bottom:84px;width:min(390px,calc(100vw - 24px));height:min(600px,calc(100vh - 120px));display:flex;flex-direction:column;background:#fff;border-radius:16px;overflow:hidden;z-index:9999999;box-shadow:0 16px 50px rgba(0,0,0,.35);opacity:0;transform:translateY(14px);transition:opacity .25s ease,transform .25s ease;pointer-events:none}" +
    "#vdc2-panel.open{opacity:1;transform:translateY(0);pointer-events:auto}" +
    "@media(max-width:479px){#vdc2-panel{right:12px;left:12px;width:auto;bottom:84px;height:min(620px,calc(100vh - 104px))}}" +
    ".vdc2-head{display:flex;align-items:center;gap:10px;background:#008069;color:#fff;padding:12px 14px;flex:0 0 auto}" +
    ".vdc2-ava{width:36px;height:36px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;font-size:17px;color:#008069;flex:0 0 auto}" +
    ".vdc2-who{display:flex;flex-direction:column;line-height:1.25;min-width:0}" +
    ".vdc2-who strong{font-size:16px;color:#fff}" +
    "#vdc2-wa{margin-left:auto;width:34px;height:34px;border-radius:50%;background:#25D366;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex:0 0 auto}" +
    "#vdc2-wa img{width:20px;height:20px}" +
    "#vdc2-close{background:none;border:0;color:#fff;font-size:26px;line-height:1;cursor:pointer;padding:0 0 0 8px;flex:0 0 auto}" +
    ".vdc2-langs{display:flex;gap:6px;padding:7px 10px;background:#f0f2f5;flex:0 0 auto;overflow-x:auto;scrollbar-width:none}" +
    ".vdc2-langs::-webkit-scrollbar{display:none}" +
    ".vdc2-lang{background:#fff;border:1px solid #c5cdd3;color:#111b21;border-radius:14px;padding:4px 11px;font-size:12px;cursor:pointer;white-space:nowrap}" +
    ".vdc2-lang.sel{background:#008069;border-color:#008069;color:#fff;font-weight:700}" +
    "#vdc2-body{flex:1 1 auto;overflow-y:auto;padding:12px 10px;display:flex;flex-direction:column;gap:8px;background:#ECE5DD}" +
    ".vdc2-msg{max-width:86%;padding:8px 12px;border-radius:10px;font-size:14px;line-height:1.45;word-wrap:break-word;color:#111b21}" +
    ".vdc2-msg.bot{background:#fff;align-self:flex-start;border-top-left-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.08)}" +
    ".vdc2-msg.user{background:#D9FDD3;color:#111b21;align-self:flex-end;border-top-right-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.08)}" +
    ".vdc2-msg a{color:#027e63;font-weight:600}" +
    ".vdc2-actions{display:flex;flex-wrap:wrap;gap:6px;align-self:flex-start;max-width:92%}" +
    ".vdc2-actions a{display:inline-flex;align-items:center;gap:5px;background:#008069;color:#fff;font-weight:700;font-size:12.5px;border-radius:999px;padding:7px 13px;text-decoration:none;box-shadow:0 2px 5px rgba(0,128,105,.3)}" +
    ".vdc2-typing{align-self:flex-start;background:#fff;border-radius:10px;padding:10px 14px;display:flex;gap:4px;box-shadow:0 1px 1px rgba(0,0,0,.08)}" +
    ".vdc2-typing i{width:7px;height:7px;border-radius:50%;background:#8fbfb4;animation:vdc2b 1.2s infinite}" +
    ".vdc2-typing i:nth-child(2){animation-delay:.15s}.vdc2-typing i:nth-child(3){animation-delay:.3s}" +
    "@keyframes vdc2b{0%,80%,100%{opacity:.35;transform:translateY(0)}40%{opacity:1;transform:translateY(-3px)}}" +
    ".vdc2-chips{display:flex;gap:6px;padding:6px 10px;background:#ECE5DD;flex:0 0 auto;overflow-x:auto;scrollbar-width:none}" +
    ".vdc2-chips::-webkit-scrollbar{display:none}" +
    ".vdc2-chip{background:#fff;border:1px solid #008069;color:#075E54;border-radius:14px;padding:5px 10px;font-size:11.5px;cursor:pointer;white-space:nowrap;flex:0 0 auto}" +
    ".vdc2-chip:hover{background:#e7f5f1}" +
    ".vdc2-form{display:flex;flex-direction:column;gap:6px;align-self:flex-start;background:#fff;border-radius:10px;padding:12px;box-shadow:0 1px 1px rgba(0,0,0,.08);width:86%}" +
    ".vdc2-form input{border:1px solid #d1d7db;border-radius:8px;padding:9px 11px;font-size:13.5px;outline:none;color:#111b21;background:#fff}" +
    ".vdc2-form button{background:#008069;color:#fff;border:none;border-radius:8px;padding:10px;font-weight:700;font-size:13.5px;cursor:pointer}" +
    "#vdc2-inputrow{display:flex;gap:7px;padding:9px 10px;background:#f0f2f5;border-top:1px solid #e0e4e7;flex:0 0 auto;align-items:center}" +
    "#vdc2-input{flex:1;border:1px solid #d1d7db;border-radius:22px;padding:10px 14px;font-size:14px;outline:none;background:#fff;color:#111b21}" +
    "#vdc2-send{width:42px;height:42px;border:0;border-radius:50%;background:#008069;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:0 0 auto}" +
    "#vdc2-mic{width:42px;height:42px;border-radius:50%;background:#fff;border:1px solid #d1d7db;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:0 0 auto;transition:background .2s}" +
    "#vdc2-mic.rec{background:#e0492f;border-color:#e0492f;animation:vdc2pulse 1.2s infinite}" +
    "#vdc2-mic.rec svg{fill:#fff}" +
    ".vdc2-foot{margin:0;padding:4px 12px 8px;background:#f0f2f5;font-size:10.5px;color:#667781;text-align:center;flex:0 0 auto}";
  document.head.appendChild(css);

  /* ---------- markup ---------- */
  var WA_ICON = "https://cdn.shopify.com/s/files/1/0640/6691/2445/files/WhatsApp.svg?v=1762303924";
  var MIC_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="#008069"><path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2z"/></svg>';
  var wrap = document.createElement("div");
  wrap.innerHTML =
    '<button id="vdc2-launch" type="button" aria-label="Chat with us">' +
    '  <img src="' + WA_ICON + '" alt="" width="30" height="30" decoding="async" fetchpriority="low">' +
    '</button>' +
    '<section id="vdc2-panel" role="dialog" aria-label="Vape Dokha chat">' +
    '  <header class="vdc2-head">' +
    '    <span class="vdc2-ava">✦</span>' +
    '    <span class="vdc2-who"><strong>Vape Dokha</strong></span>' +
    '    <button id="vdc2-wa" type="button" aria-label="WhatsApp"><img src="' + WA_ICON + '" alt=""></button>' +
    '    <button id="vdc2-close" aria-label="Close">×</button>' +
    '  </header>' +
    '  <div class="vdc2-langs" id="vdc2-langs"></div>' +
    '  <div id="vdc2-body" aria-live="polite"></div>' +
    '  <div class="vdc2-chips" id="vdc2-chips">' +
    '    <button class="vdc2-chip" data-act="track"></button>' +
    '    <button class="vdc2-chip" data-act="ship"></button>' +
    '    <button class="vdc2-chip" data-act="order"></button>' +
    '  </div>' +
    '  <div id="vdc2-inputrow">' +
    '    <input id="vdc2-input" type="text" maxlength="600" autocomplete="off">' +
    '    <button id="vdc2-mic" aria-label="Voice message" title="Voice message">' + MIC_SVG + '</button>' +
    '    <button id="vdc2-send" aria-label="Send"><svg viewBox="0 0 24 24" width="20" height="20" fill="#fff"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"/></svg></button>' +
    '  </div>' +
    '  <p class="vdc2-foot">18+ only · nicotine is addictive</p>' +
    '</section>';
  document.body.appendChild(wrap);

  var launch = document.getElementById("vdc2-launch"),
      panel = document.getElementById("vdc2-panel"),
      closeBtn = document.getElementById("vdc2-close"),
      waBtn = document.getElementById("vdc2-wa"),
      body = document.getElementById("vdc2-body"),
      input = document.getElementById("vdc2-input"),
      sendBtn = document.getElementById("vdc2-send"),
      micBtn = document.getElementById("vdc2-mic"),
      langsRow = document.getElementById("vdc2-langs"),
      chipsRow = document.getElementById("vdc2-chips");

  /* ---------- language selector ---------- */
  function applyLang(code, rerender){
    sel = code;
    try { localStorage.setItem(KEY + "Lang", code); } catch (e) {}
    var L = LANGS[code];
    input.placeholder = L.ph;
    var chipBtns = chipsRow.querySelectorAll(".vdc2-chip");
    chipBtns[0].textContent = L.chips[0];
    chipBtns[1].textContent = L.chips[1];
    chipBtns[2].textContent = L.chips[2];
    body.setAttribute("dir", L.rtl ? "rtl" : "ltr");
    var btns = langsRow.querySelectorAll(".vdc2-lang");
    btns.forEach(function(b){ b.classList.toggle("sel", b.dataset.code === code); });
    if (rerender) renderHistory();
  }
  Object.keys(LANGS).forEach(function(code){
    var b = document.createElement("button");
    b.className = "vdc2-lang"; b.dataset.code = code; b.textContent = LANGS[code].label;
    b.addEventListener("click", function(){ applyLang(code, true); });
    langsRow.appendChild(b);
  });

  /* ---------- state (localStorage — remembers the customer for 30 days) ---------- */
  var history = [];
  try {
    var ts = parseInt(localStorage.getItem(KEY + "Ts") || "0", 10) || 0;
    if (ts && Date.now() - ts > 30 * 24 * 3600 * 1000) { localStorage.removeItem(KEY); localStorage.removeItem(KEY + "Cid"); localStorage.removeItem(KEY + "Mid"); }
    history = JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch (e) {}
  function saveHistory(){ try { localStorage.setItem(KEY, JSON.stringify(history.slice(-30))); localStorage.setItem(KEY + "Ts", String(Date.now())); } catch (e) {} }
  var cid = null, lastMid = 0;
  try { cid = localStorage.getItem(KEY + "Cid") || null; lastMid = parseInt(localStorage.getItem(KEY + "Mid") || "0", 10) || 0; } catch (e) {}
  function saveCid(){ try { if (cid) localStorage.setItem(KEY + "Cid", cid); localStorage.setItem(KEY + "Mid", String(lastMid)); } catch (e) {} }

  function waUrl(){
    var lastUser = "";
    for (var i = history.length - 1; i >= 0; i--) { if (history[i].role === "user") { lastUser = history[i].content; break; } }
    var msg = "Hi Vape Dokha! 👋" + (lastUser ? "\nI was asking your site assistant: " + lastUser.slice(0, 200) : "") + "\n\nPage: " + location.href;
    return "https://wa.me/" + WHATSAPP + "?text=" + encodeURIComponent(msg);
  }
  waBtn.addEventListener("click", function(){ window.open(waUrl(), "_blank", "noopener"); });

  /* ---------- rendering ---------- */
  function esc(s){ var d=document.createElement("div"); d.textContent=s; return d.innerHTML; }
  function fmt(text){
    var h = esc(text);
    h = h.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1<\/a>');
    h = h.replace(/(^|[^"'>])(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noopener">link<\/a>');
    h = h.replace(/\*\*([^*]+)\*\*/g, "<strong>$1<\/strong>");
    h = h.replace(/\n/g, "<br>");
    return h;
  }
  function addMsg(role, text){
    var d = document.createElement("div");
    d.className = "vdc2-msg " + (role === "user" ? "user" : "bot");
    d.innerHTML = role === "user" ? esc(text) : fmt(text);
    body.appendChild(d); body.scrollTop = body.scrollHeight;
    return d;
  }
  function addActions(actions){
    if (!actions || !actions.length) return;
    var w = document.createElement("div");
    w.className = "vdc2-actions";
    actions.slice(0, 6).forEach(function(a){
      if (!a || !a.url) return;
      var el = document.createElement("a");
      el.href = a.url; el.textContent = a.label || "Open";
      var sameSite = a.url.indexOf("vapedokha.com") > -1 && a.url.indexOf("wa.me") === -1;
      if (!sameSite) { el.target = "_blank"; el.rel = "noopener"; }
      w.appendChild(el);
    });
    body.appendChild(w); body.scrollTop = body.scrollHeight;
  }
  function typing(on){
    var t = document.getElementById("vdc2-typing");
    if (on && !t) { t = document.createElement("div"); t.id="vdc2-typing"; t.className="vdc2-typing"; t.innerHTML="<i></i><i></i><i></i>"; body.appendChild(t); body.scrollTop=body.scrollHeight; }
    if (!on && t) t.remove();
  }
  function renderHistory(){
    body.innerHTML = "";
    addMsg("bot", LANGS[sel].greet);
    history.forEach(function(m){
      if (m.role === "user") addMsg("user", m.content);
      else { addMsg("bot", m.content); if (m.actions) addActions(m.actions); }
    });
  }
  function receiveBot(text, actions){
    typing(false);
    addMsg("bot", text);
    if (actions && actions.length) addActions(actions);
    history.push({ role: "assistant", content: text, actions: actions || null }); saveHistory();
  }

  /* ---------- live polling (owner can jump in from the dashboard) ---------- */
  var pollTimer = null;
  function poll(){
    if (!cid) return;
    fetch(WORKER_URL + "/poll?cid=" + encodeURIComponent(cid) + "&after=" + lastMid)
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (!j || !j.success || !j.messages) return;
        j.messages.forEach(function(m){
          if (m.id > lastMid) lastMid = m.id;
          receiveBot(m.content, m.actions);
        });
        saveCid();
      })["catch"](function(){});
  }
  function startPolling(){ if (!pollTimer) pollTimer = setInterval(poll, 3500); }
  function stopPolling(){ if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }

  /* ---------- panel open/close ---------- */
  function openPanel(){ applyLang(sel, false); renderHistory(); panel.classList.add("open"); document.body.classList.add("vd-concierge-open"); startPolling(); setTimeout(function(){ input.focus(); }, 250); }
  function closePanel(){ panel.classList.remove("open"); document.body.classList.remove("vd-concierge-open"); stopPolling(); }
  launch.addEventListener("click", function(){ panel.classList.contains("open") ? closePanel() : openPanel(); });
  closeBtn.addEventListener("click", closePanel);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape" && panel.classList.contains("open")) closePanel(); });

  /* ---------- send to worker ---------- */
  var busy = false;
  function handleResponse(data){
    if (data.cid) { cid = data.cid; }
    if (data.mid && data.mid > lastMid) lastMid = data.mid;
    saveCid();
    typing(false);
    if (data.human) return;
    if (data.answer) {
      addMsg("bot", data.answer);
      if (data.actions && data.actions.length) addActions(data.actions);
      history.push({ role: "assistant", content: data.answer, actions: data.actions || null }); saveHistory();
    }
  }
  function failFallback(){
    typing(false);
    var fallback = "Connection issue — tap below and a human will help you right away on WhatsApp.";
    addMsg("bot", fallback);
    addActions([{ label: "💬 WhatsApp", url: waUrl() }]);
    history.push({ role: "assistant", content: fallback, actions: [{ label: "💬 WhatsApp", url: waUrl() }] }); saveHistory();
  }
  async function ask(text){
    text = (text || "").trim();
    if (!text || busy) return;
    busy = true;
    addMsg("user", text);
    history.push({ role: "user", content: text }); saveHistory();
    typing(true);
    try {
      var r = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: text, cid: cid, lang: LANGS[sel].name, page: location.href, messages: history.slice(-14) })
      });
      var data = await r.json();
      if (!r.ok || !data.success) throw new Error("bad response");
      handleResponse(data);
    } catch (e) { failFallback(); }
    busy = false;
  }
  sendBtn.addEventListener("click", function(){ ask(input.value); input.value = ""; });
  input.addEventListener("keydown", function(e){ if (e.key === "Enter") { ask(input.value); input.value = ""; } });

  /* ---------- voice notes ---------- */
  var rec = null, recChunks = [], recTimer = null;
  function recMime(){
    if (window.MediaRecorder) {
      if (MediaRecorder.isTypeSupported("audio/webm")) return "audio/webm";
      if (MediaRecorder.isTypeSupported("audio/mp4")) return "audio/mp4";
    }
    return "";
  }
  async function sendVoice(blob, mime){
    if (busy) return;
    busy = true;
    var userEl = addMsg("user", "🎤 …");
    typing(true);
    try {
      var b64 = await new Promise(function(res, rej){
        var fr = new FileReader();
        fr.onload = function(){ res(String(fr.result).split(",")[1] || ""); };
        fr.onerror = rej;
        fr.readAsDataURL(blob);
      });
      var r = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ audio: { data: b64, mime: mime }, cid: cid, lang: LANGS[sel].name, page: location.href })
      });
      var data = await r.json();
      if (!r.ok || !data.success) throw new Error("bad response");
      if (data.transcript) {
        userEl.innerHTML = esc("🎤 " + data.transcript);
        history.push({ role: "user", content: "🎤 " + data.transcript }); saveHistory();
      }
      handleResponse(data);
    } catch (e) {
      userEl.innerHTML = esc("🎤 ✕");
      typing(false);
    }
    busy = false;
  }
  micBtn.addEventListener("click", async function(){
    if (rec && rec.state === "recording") { rec.stop(); return; }
    var mime = recMime();
    if (!mime || !navigator.mediaDevices) { addMsg("bot", "Voice isn’t supported on this browser — please type instead 🙏"); return; }
    try {
      var stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      recChunks = [];
      rec = new MediaRecorder(stream, { mimeType: mime });
      rec.ondataavailable = function(e){ if (e.data && e.data.size) recChunks.push(e.data); };
      rec.onstop = function(){
        micBtn.classList.remove("rec");
        clearTimeout(recTimer);
        stream.getTracks().forEach(function(t){ t.stop(); });
        var blob = new Blob(recChunks, { type: mime });
        if (blob.size > 300) sendVoice(blob, mime);
      };
      rec.start();
      micBtn.classList.add("rec");
      recTimer = setTimeout(function(){ if (rec && rec.state === "recording") rec.stop(); }, 60000);
    } catch (e) {
      addMsg("bot", "I couldn’t access the microphone — please allow it in your browser, or just type 🙏");
    }
  });

  /* ---------- quick chips ---------- */
  chipsRow.addEventListener("click", function(e){
    var b = e.target.closest(".vdc2-chip");
    if (!b) return;
    if (b.dataset.act === "ship") { ask(LANGS[sel].qShip); return; }
    if (b.dataset.act === "order") { ask(LANGS[sel].qOrder); return; }
    if (b.dataset.act === "track") showTrackForm();
  });

  function showTrackForm(){
    if (document.getElementById("vdc2-trackform")) return;
    var f = document.createElement("div");
    f.className = "vdc2-form"; f.id = "vdc2-trackform";
    f.innerHTML = '<strong style="font-size:13.5px;color:#111b21">📦</strong>' +
      '<input id="vdc2-tf-num" type="text" inputmode="numeric" placeholder="Order # (e.g. 1053)">' +
      '<input id="vdc2-tf-email" type="email" placeholder="Email used at checkout">' +
      '<button type="button" id="vdc2-tf-go">OK<\/button>';
    body.appendChild(f); body.scrollTop = body.scrollHeight;
    document.getElementById("vdc2-tf-go").addEventListener("click", function(){
      var n = document.getElementById("vdc2-tf-num").value.trim();
      var m = document.getElementById("vdc2-tf-email").value.trim();
      if (!n || !m) return;
      f.remove();
      ask("Track my order. Order number: " + n + " — checkout email: " + m);
    });
  }

  /* ---------- search-bar ✦ chip (second entrance) ---------- */
  (function relocateLauncher(){
    try {
      var searchForm = document.querySelector('header form[action*="/search"], .site-header form[action*="/search"], form[action*="/search"]');
      if (!searchForm) return;
      var style = document.createElement("style");
      style.textContent = "#vd-ask-ai-chip{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:linear-gradient(45deg,#b8912c,#d4af37);color:#1a1008;font-weight:700;border:none;border-radius:50%;padding:0;margin:0;cursor:pointer;font-size:17px;box-shadow:0 2px 8px rgba(212,175,55,.35)}#vd-ask-ai-chip:hover{filter:brightness(1.08)}";
      document.head.appendChild(style);
      var chip = document.createElement("button");
      chip.type = "button"; chip.id = "vd-ask-ai-chip"; chip.innerHTML = "✦";
      chip.title = "Ask AI"; chip.setAttribute("aria-label", "Ask AI");
      var getHolder = window.vdGetChipHolder || function(form){
        var field = form.querySelector(".field") || form;
        var holder = field.querySelector("#vd-search-chips");
        if (holder) return holder;
        if (getComputedStyle(field).position === "static") field.style.position = "relative";
        var submit = field.querySelector('.search__button, button[type="submit"], input[type="submit"]');
        holder = document.createElement("span");
        holder.id = "vd-search-chips";
        holder.style.cssText = "position:absolute;top:50%;transform:translateY(-50%);display:flex;align-items:center;gap:4px;z-index:3;";
        field.appendChild(holder);
        var place = function(){
          var fr = field.getBoundingClientRect();
          if (!fr.width) return;
          var br = submit ? submit.getBoundingClientRect() : null;
          var onRight = !br || !br.width || (br.left + br.width/2 > fr.left + fr.width/2);
          if (onRight) { holder.style.right = (br && br.width ? Math.round(fr.right - br.left + 6) : 8) + "px"; holder.style.left = "auto"; }
          else { holder.style.left = Math.round(br.right - fr.left + 6) + "px"; holder.style.right = "auto"; }
          var inp = field.querySelector('input.search__input, input[type="search"]');
          if (inp) {
            var hr = holder.getBoundingClientRect();
            if (onRight) inp.style.paddingRight = Math.round(fr.right - hr.left + 10) + "px";
            else inp.style.paddingLeft = Math.round(hr.right - fr.left + 10) + "px";
          }
        };
        holder.__vdPlace = place;
        var kick = function(){ requestAnimationFrame(place); };
        holder.__vdKick = kick;
        kick();
        window.addEventListener("load", kick);
        setTimeout(place, 600); setTimeout(place, 1500); setTimeout(place, 3000);
        window.addEventListener("resize", kick);
        return holder;
      };
      var holder = getHolder(searchForm);
      holder.appendChild(chip);
      if (holder.__vdKick) { holder.__vdKick(); setTimeout(holder.__vdPlace, 600); }
      chip.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); panel.classList.contains("open") ? closePanel() : openPanel(); });
      document.body.classList.add("vd-chip-active");
    } catch (e) {}
  })();

  applyLang(sel, false);
});
